<template>
  <!-- <div class="alert" v-if="isShow > 0"> -->
  <div class="alert">
    <AlertContent
      v-for="alert in getAlerts"
      :key="alert.id"
      @remove="removeAlert(alert.id)"
      :message="alert.message"
      :type="alert.type"
      :autoclose="alert.autoclose"
    />
  </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import AlertContent from '@/components/AlertContent.vue';

const store = useStore();
const route = useRoute();

const getAlerts = computed(() => store.getters.getAlerts);

const removeAlert = (id) => {
  store.dispatch('REMOVE_ALERT', id);
};

watch(() => route.path, (newPath, oldPath) => {
  if (newPath !== oldPath) {
    store.dispatch('DELETE_ALERT');
  }
});
</script>
